import React, { Component, useState, useEffect, useMemo, useRef, useCallback } from 'react';

import loadable from "@loadable/component";

import {
  BrowserRouter,
  Routes,
  createBrowserRouter,
  RouterProvider,
  Route,
  Navigate,
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';


import PopMoments from "./components/pages/pop/PopMoments";
import PopCredits from "./components/pages/pop/PopCredits";
import PopReactions from "./components/pages/pop/PopReactions";
import PopComments from "./components/pages/pop/PopComments";
import PopFulltext from "./components/pages/pop/PopFulltext";
import PopVideo from "./components/pages/pop/PopVideo";

import ShareBox from "./components/pages/pop/ShareBox";
import SearchPage from "./components/pages/pop/SearchPage";
import LanguagesBox from "./components/pages/pop/LanguagesBox";

import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";


import { isLogin } from './utils';


import i18n from "./i18n";

import useAppStore from './store/appStore';

import LoadingPage from "./components/pages/home/LoadingPage";

const HomePage = loadable(() => import("./components/pages/home/HomePage"), {
   fallback: <LoadingPage />
});

const HomeinPage = loadable(() => import("./components/pages/home/HomeinPage"), {
   fallback: <LoadingPage />
});

const StorryPage = loadable(() => import("./components/pages/home/StorryPage"), {
   fallback: <LoadingPage />
});


const MomentPage = loadable(() => import("./components/pages/home/MomentPage"), {
   fallback: <LoadingPage />
});

const SigninPage = loadable(() => import("./components/pages/auth/SigninPage"), {
   fallback: <LoadingPage />
});
const SignupPage = loadable(() => import("./components/pages/auth/SignupPage"), {
   fallback: <LoadingPage />
});
const ForgotPswdPage = loadable(() => import("./components/pages/auth/ForgotPswdPage"), {
   fallback: <LoadingPage />
});
const NewPswdPage = loadable(() => import("./components/pages/auth/NewPswdPage"), {
   fallback: <LoadingPage />
});
const CodePswdPage = loadable(() => import("./components/pages/auth/CodePswdPage"), {
   fallback: <LoadingPage />
});

const MyaccountPage = loadable(() => import("./components/pages/home/MyaccountPage"), {
   fallback: <LoadingPage />
});

const SaveditemsPage = loadable(() => import("./components/pages/home/SaveditemsPage"), {
   fallback: <LoadingPage />
});

const AboutPage = loadable(() => import("./components/pages/home/AboutPage"), {
   fallback: <LoadingPage />
});

const GetStorryPage = loadable(() => import("./components/pages/general/GetStorryPage"), {
       fallback: <LoadingPage />
});

const MemoireVivanteDuCongoPage = loadable(() => import("./components/pages/general/MemoireVivanteDuCongoPage"), {
   fallback: <LoadingPage />
});

const AproposMemoireVivanteDuCongoPage = loadable(() => import("./components/pages/general/AproposMemoireVivanteDuCongoPage"), {
   fallback: <LoadingPage />
});

const JoinMemoireVivanteDuCongoPage = loadable(() => import("./components/pages/general/JoinMemoireVivanteDuCongoPage"), {
   fallback: <LoadingPage />
});

const HelpPage = loadable(() => import("./components/pages/general/HelpPage"), {
       fallback: <LoadingPage />
});

const HelpinPage = loadable(() => import("./components/pages/general/HelpinPage"), {
       fallback: <LoadingPage />
});

const SubscriptionFlowPage = loadable(() => import("./components/pages/general/SubscriptionFlowPage"), {
       fallback: <LoadingPage />
});

const PrevContractPage = loadable(() => import("./components/pages/home/PrevContractPage"), {
   fallback: <LoadingPage />
});

const NoMatch = loadable(() => import("./components/pages/home/NoMatch"), {
   fallback: <LoadingPage />
});


const algoliasearch = require('algoliasearch');
var client = algoliasearch('HKB157K3KU', '357f2b37e5ef8c12f7b90877758ff663');


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;




const TOKEN_KEY = 'storrypagejwtToken';
const BO_USER = 'storrypageUser';


const ProtectedRoute = ({ isSignedin, children }) => {

  const location = useLocation();
  const pathWithoutSlash = location.pathname.startsWith('/')
    ? location.pathname.slice(1)
    : location.pathname;

  localStorage.setItem("storrypageAfter", `${pathWithoutSlash}`);

  if (!isSignedin) {
    return <Navigate to={`/signin?after=${pathWithoutSlash}`} replace />;
  }

  return children;
};

const PublicRoute = ({ isSignedin, children }) => {


  if (isLogin()) {
    return <Navigate to="/home" replace />;
  }



  return children;
};

const App = () => {



  const [displayHeader, seDisplayHeader] = useState(true);

  const [displayPop, setDisplayPop] = useState('none');
  const [bodyPos, setBodyPos] = useState(0);
  const [currentObject, setCurrentObject] = useState(null);
  const [currentBody, setCurrentBody] = useState(null);
  const [currentTitle, setCurrentTitle] = useState(null);
  const [followed, setFollowed] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const [query, setQuery] = useState('');
  const [queryResults, setQueryResults] = useState([]);
  const [displaySearch, setDisplaySearch] = useState(false);


  const creditsRef = useRef(null);
  const momentsRef = useRef(null);
  const reactionsRef = useRef(null);
  const commentsRef = useRef(null);
  const fulltextRef = useRef(null);
  const searchRef = useRef(null);
  const videoRef = useRef(null);


  let currUser, thumb = null;
  if (localStorage.getItem(BO_USER)) {
      //alert(JSON.stringify(localStorage.getItem(BO_USER)))
      currUser = localStorage.getItem(BO_USER);

      const _signUser = JSON.parse(currUser);

      thumb = _signUser.thumbnail;



  }
  else
  {
     currUser =null;
  }




  const [sinUser, setSinUser] = useState(currUser);
  const [thumbnail, setThumbnail] = useState(thumb);

  const location = useLocation();

  const isPRoute = () => {
    const pathname = location.pathname;
    return /^\/p\/[^/]+$/.test(pathname); // Match /p/:id
  }


  const lastTriggerParam = useAppStore((state) => state.lastTriggerParam);
   const resetTriggerParam = useAppStore((state) => state.resetTriggerParam);

    useEffect(() => {
      if (lastTriggerParam !== null) {
        //alert(`App a reçu : ${lastTriggerParam}`);

        seDisplayHeader(!lastTriggerParam);

        // Puis reset si tu veux éviter les doublons
        resetTriggerParam();
      }
    }, [lastTriggerParam, resetTriggerParam]);



  /*  const setViewportHeight = () => {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    }; */




  useEffect(() => {


        window.onorientationchange = (event) => {
            if (isTablet)
            {
               window.location.reload();
            }
        };


        //window.addEventListener('resize', setViewportHeight);
        //setViewportHeight();


       fetch('https://api.ipstack.com/check?access_key=9cd4ffbf45a257de9e644d4d875a9465')
            .then((response) => response.json())
            .then((responseData) => {
                 //alert("App. Store: " + JSON.stringify(responseData));

                 global.country = responseData.country_code;
                 global.continent = responseData.continent_code;
                 global.ip = responseData.ip;

                 if (localStorage.getItem("language"))
                 {
                    i18n.changeLanguage(localStorage.getItem("language"));
                 }
                 else
                 {
                     if (global.country === 'CD' || global.country === 'FR' || global.country === 'BE' || global.country === 'TG' || global.country === 'CI')
                     {
                         i18n.changeLanguage('fr');
                     }
                     else
                     {
                         i18n.changeLanguage('en');
                     }
                 }




                 //alert(localStorage.getItem("language"))

              })
             .catch(function(error) {
                   i18n.changeLanguage('en');
             });


             if (sinUser !== null)
             {
                 const __signUser = JSON.parse(currUser);
                 checkChanges(__signUser.uid);
             }



   }, []);


   const onPreviewMoments = (object, user) => {
     setCurrentObject(object);
     previewPop('Moments');

     setTimeout(() => {
       if (momentsRef.current) {
         momentsRef.current.displayInnerDiv();
       }
     }, 100);
   }

   const onPreviewCredits = (object, user) => {
     setCurrentObject(object);
     previewPop('Credits');



     setTimeout(() => {
       if (creditsRef.current) {
         creditsRef.current.displayInnerDiv();
       }
     }, 100);
   }


   const previewFullText = (title, description) => {
       setCurrentBody(description);
       setCurrentTitle(title);
       previewPop('Fulltext');

       setTimeout(() => {
         if (fulltextRef.current) {
           fulltextRef.current.displayInnerDiv();
         }
       }, 100);
   }


   const previewPop = (name) => {
     var _bodyPos  = window.pageYOffset || document.documentElement.scrollTop;

     setDisplayPop(name);
     setBodyPos(_bodyPos);


     document.body.style.overflow = 'hidden';
   }

   const previewReactions = (object) => {
       setCurrentObject(object);
       previewPop('Reactions');



       setTimeout(() => {
         if (reactionsRef.current) {
           reactionsRef.current.displayInnerDiv();
         }
       }, 100);
   }

   const handleOnPreviewComments = (object) => {
     setCurrentObject(object);
     previewPop('Comments');



     setTimeout(() => {
       if (commentsRef.current) {
         commentsRef.current.displayInnerDiv();
       }
     }, 100);
   }




    const quitDisplayPop = () => {
        document.body.style.overflow = '';

        setDisplayPop('none');
        setCurrentObject(null);
        setCurrentBody(null);

    }


    const passFollowedToParent = (bool) => {
    //  setFollowed(bool);
    }

    const goToSelectedMoment = (item, index) => {
      // alert(item.objectID + ' /// ' + index)
    }




    const onUpdateThumbnail = (url) => {

     // alert(url);
      setThumbnail(url);
    }

    const checkChanges = (uid) => {


      var index = client.initIndex('User');


      index
      .search('*',
      {
        page: 0,
       filters: `searchable_id:${uid}`,
       attributesToRetrieve: ['name', 'screenname', 'email', 'picture', 'access_token', 'dcareer_account_auth_type', 'dcareer_account_parent_uid']
       //hitsPerPage: this.state.sizePerPage
      })
      .then(({ hits, nbPages, page, nbHits }) =>
        {
           if (nbHits > 0)
           {
             const user = hits[0];
             let res = JSON.parse(currUser);

             res.name = user.name;
             res.screenname = user.screenname;
             res.email = user.email;
             res.thumbnail = user.picture;

             setThumbnail(user.picture);

           //  alert(hits[0].email + ' // ' + res.dcareer_account_auth_type + ' // ' + res.dcareer_account_parent_uid)

             const signedUserStr = JSON.stringify(res);

             setSinUser(signedUserStr);
             localStorage.setItem("bejiUser", signedUserStr);

           }

       });


    }


    const handleSearchChange = (query, objects) => {
        //alert('>>> Search  : ' + query + ' /// ' + objects.length);

        setQuery(query);
        setQueryResults(objects);

        if (query === '')
        {
          setDisplaySearch(false);
           document.body.style.overflow = 'auto';
        }
        else
        {
          setDisplaySearch(true);
           document.body.style.overflow = 'hidden';
        }

    }

    const quitSearch = () => {
       setDisplaySearch(false);
        document.body.style.overflow = 'auto';
    }

    const onPreviewVideo = (poster, url) => {
      //setSelectedVideo(v);
      previewPop('Video');

      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.displayInnerDiv(poster, url);
        }
      }, 100);
    }


   return (
     <Translation>
       {
           t =>
           <>

            {displayPop === 'Moments' && currentObject !== null && <PopMoments ref={momentsRef} selectedObject={currentObject} onClose={quitDisplayPop} goToSelectedMoment={goToSelectedMoment} followed={followed}/>}
            {displayPop === 'Credits' && currentObject !== null && <PopCredits ref={creditsRef} selectedObject={currentObject} onClose={quitDisplayPop}/>}
            {displayPop === 'Reactions' && currentObject !== null && <PopReactions ref={reactionsRef} selectedObject={currentObject} sinUser={sinUser} onClose={quitDisplayPop}/>}
            {displayPop === 'Comments' && currentObject !== null && <PopComments ref={commentsRef} selectedObject={currentObject} sinUser={sinUser} onClose={quitDisplayPop}/>}
            {displayPop === 'Fulltext' && currentBody !== null && <PopFulltext ref={fulltextRef} currentTitle={currentTitle} currentBody={currentBody} onClose={quitDisplayPop}/>}

            {displayPop === 'Video' &&  <PopVideo ref={videoRef} onClose={quitDisplayPop}/>}

            {displayPop === 'Share' && currentObject === null && 1===2 && <ShareBox selectedObject={currentObject} onClose={quitDisplayPop}/>}
            {displayPop === 'Languages' && currentObject === null && 1===2 && <LanguagesBox selectedObject={currentObject} onClose={quitDisplayPop}/>}

            {displaySearch && <SearchPage ref={searchRef} query={query} queryResults={queryResults} quitSearch={quitSearch} onPreviewMoments={onPreviewMoments} onPreviewCredits={onPreviewCredits}/>}

            {displayHeader && <Header isSignedin={isLogin()} sinUser={sinUser} thumbnail={thumbnail} handleSearchChange={handleSearchChange}/>}

             <Routes>
               <Route path="/" element={<PublicRoute isSignedin={false}><HomePage onPreviewMoments={onPreviewMoments} onPreviewCredits={onPreviewCredits} onPreviewVideo={onPreviewVideo}/></PublicRoute>} />

               <Route path="/signin" element={<PublicRoute isSignedin={false}><SigninPage /></PublicRoute>} />
               <Route path="/signup" element={<PublicRoute isSignedin={false}><SignupPage /></PublicRoute>} />
               <Route path="/resetpswd" element={<PublicRoute isSignedin={false}><ForgotPswdPage /></PublicRoute>} />
               <Route path="/home" element={<ProtectedRoute isSignedin={isLogin()}><HomeinPage sinUser={sinUser} onPreviewMoments={onPreviewMoments} onPreviewCredits={onPreviewCredits}/></ProtectedRoute>} />
               <Route path="/p/:id" element={<StorryPage sinUser={sinUser} handleOnPreviewComments={handleOnPreviewComments} previewReactions={previewReactions} previewFullText={previewFullText} onPreviewMoments={onPreviewMoments} onPreviewCredits={onPreviewCredits} passFollowedToParent={passFollowedToParent}/>} />
               <Route path="/m/:id" element={<MomentPage sinUser={sinUser} handleOnPreviewComments={handleOnPreviewComments} previewReactions={previewReactions} previewFullText={previewFullText} onPreviewMoments={onPreviewMoments} onPreviewCredits={onPreviewCredits} passFollowedToParent={passFollowedToParent}/>} />
               <Route path="/myaccount" element={<ProtectedRoute isSignedin={isLogin()}><MyaccountPage sinUser={sinUser} onUpdateThumbnail={onUpdateThumbnail}/></ProtectedRoute>} />
               <Route path="/saveditems" element={<ProtectedRoute isSignedin={isLogin()}><SaveditemsPage sinUser={sinUser}/></ProtectedRoute>} />
               <Route path="/about" element={<AboutPage sinUser={sinUser}/>} />
               <Route path="/get-a-storrypage" element={<GetStorryPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
               <Route path="/obtenir-une-storrypage" element={<GetStorryPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
               <Route path="/living-memory-of-congo" element={<MemoireVivanteDuCongoPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
               <Route path="/memoire-vivante-du-congo" element={<MemoireVivanteDuCongoPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
               <Route path="/living-memory-of-congo/about" element={<AproposMemoireVivanteDuCongoPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
               <Route path="/memoire-vivante-du-congo/a-propos" element={<AproposMemoireVivanteDuCongoPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
               <Route path="/contribute-to-the-living-memory" element={<JoinMemoireVivanteDuCongoPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
               <Route path="/contribuer-a-la-memoire-vivante" element={<JoinMemoireVivanteDuCongoPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
               <Route path="/help" element={<HelpPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
               <Route path="/help/:id" element={<HelpinPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
               <Route path="/subscription_flow" element={<SubscriptionFlowPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
               <Route path="/prevcontract/:id" element={<PrevContractPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
               <Route path="*" element={<NoMatch />} />
             </Routes>


             {!isPRoute() && <Footer/>}



           </>
        }
    </Translation>
  );

}

export default App;
